import {colors} from "@unibuddy/patron";

export const PRIMARY_COLOR = colors.grey900;
export const PRIMARY_HOVER_COLOR = colors.grey700;

export const theme = {
    colors: {
        primaryColor: PRIMARY_COLOR,
        primaryHoverColor: PRIMARY_HOVER_COLOR,
    },
    Button: {
        colors: {
            primary: {
                color: "white",
                bgColor: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                hoverBgColor: PRIMARY_HOVER_COLOR,
                outlineColor: colors.blue500,
                clearColor: PRIMARY_COLOR,
                clearHoverBgColor: colors.grey50,
            },
        },
    },
};
